import axios from 'axios';

import {Group} from 'interfaces';

import {API_URL} from './constants';

const getGroups = async (): Promise<Group[]> => {
    const response = await axios.post(`${API_URL}/groups/list`);
    return response.data;
};

const saveGroups = async (groups: Group[]): Promise<Group[]> => {
    const response = await axios.post(`${API_URL}/groups/save`, {groups});
    return response.data;
};

export const groupApi = {
    getGroups,
    saveGroups
};